export interface SharingData {
    email: string;
    types: string[];
}

export interface SharingDataListState {
    [id: string]: SharingData[];
}

export interface PreviousSharingEmailState {
    emails: string[];
}

export enum SharingType {
    Quote = 'Quotes',
    Itinerary = 'Itineraries',
    Nothing = 'Nothing'
}
